import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileCard from "@Broker/@Modules/clients/board/client-board/components/views-type/dynamic/board-columns/profile-cards/profile-card.vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Colorpicker from "@Shared/components/inputs/colorpicker";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MaterialInput from "@Shared/components/inputs/material-input";
import { isValidColor } from "@Shared/@Utils/validation-rules";
import DeleteComponentModal from "../components/shared/delete-component-modal.vue";
import { UPDATE_DEFAULT_BOARD, ORDER_BOARDS, LOAD_BOARDS } from "@Broker/@Modules/clients/board/store/board-actions";
import { SELECTED_BOARD } from "@Broker/@Modules/clients/board/store/board-getters";
import { defineComponent } from "@vue/composition-api";
import { mapState, mapGetters, mapActions } from "vuex";
import { mapFields } from "@joandvgv/vuex-map-fields";
import { BOARDS } from "@Broker/@Modules/clients/board/store/board-getters";
export default defineComponent({
  name: "DuplicateClientProfileModal",
  components: {
    GenericModal,
    SimpleButton,
    Colorpicker,
    MaterialInput,
    ProfileCard,
    DeleteComponentModal
  },
  mixins: [validationMixin],
  validations: {
    labelText: {
      required
    },
    labelColor: {
      isValidColor
    }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    pin: {
      type: Boolean,
      default: false
    },
    applicationId: {
      type: [String, Number],
      default: ""
    },
    update: {
      type: Boolean,
      default: false
    },
    clientProfileDetails: {
      type: Object,
      default: () => ({})
    },
    inactive: {
      type: Boolean,
      default: false
    },
    fetchBoards: {
      type: Boolean,
      default: true
    },
    dropLeft: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "white"
    },
    toggleClass: {
      type: String,
      default: ""
    },
    menuClass: {
      type: String,
      default: ""
    },
    openOnHover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelText: "",
      labelColor: "",
      isEditingLabel: false,
      addingLabel: false,
      boardSelected: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["styles"])), mapFields("BoardStore", ["selectedBoardId"])), mapGetters("BoardStore", [SELECTED_BOARD])), mapGetters("BoardStore", [BOARDS])), {}, {
    isValid() {
      return !this.$v.$invalid && this.labelColor;
    },
    modalText() {
      return this.$t("client-profile.actions.deleteProfileLabelText");
    },
    boardsOptions() {
      return _Object$values(this.boards.byId);
    },
    selectedBoard() {
      var _context;
      return this.boardSelected ? this.boardSelected : _findInstanceProperty(_context = this.BOARDS).call(_context, board => board.id === this.clientProfileDetails.boardId);
    },
    sortedBoards() {
      var _context2;
      return _sortInstanceProperty(_context2 = [...this.BOARDS]).call(_context2, (a, b) => _parseInt(a == null ? void 0 : a.boardOrder) - _parseInt(b == null ? void 0 : b.boardOrder));
    },
    profile() {
      return this.clientProfileDetails;
    }
  }),
  mounted() {
    this.LOAD_BOARDS();
    this.resetData();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_BOARDS, UPDATE_DEFAULT_BOARD, ORDER_BOARDS])), {}, {
    handleConfirmClick() {
      this.$emit("submit", {
        labelColor: this.labelColor,
        labelText: this.labelText,
        boardId: this.selectedBoard.id ? this.selectedBoard.id : null,
        isEditingLabel: this.isEditingLabel,
        addingLabel: this.addingLabel
      });
    },
    handleDelete(cancelDeletion) {
      if (!cancelDeletion) {
        this.$emit("submit", {
          labelColor: "",
          labelText: "",
          boardId: this.selectedBoard.id ? this.selectedBoard.id : null,
          isEditingLabel: this.isEditingLabel
        });
      }
      this.$refs.deleteComponentModal.hide();
    },
    transferProfile(boardId) {
      var _context3;
      this.boardSelected = _findInstanceProperty(_context3 = this.BOARDS).call(_context3, board => board.id === boardId);
    },
    hideModal() {
      this.$refs.duplicateModal.hide();
      this.resetData();
    },
    handleHidden($event) {
      this.$emit("hidden", $event);
    },
    resetData() {
      if (this.isEditingLabel) {
        this.labelText = this.clientProfileDetails.labelText || "";
        this.labelColor = this.clientProfileDetails.labelColour || this.styles.primary || "#000000";
      } else {
        this.labelText = "";
        this.labelColor = "";
      }
      this.boardSelected = null;
    },
    showModal(isEditingLabel, addingLabel) {
      this.isEditingLabel = isEditingLabel;
      this.addingLabel = addingLabel;
      if (!isEditingLabel) {
        this.resetData();
      }
      this.$refs.duplicateModal.show();
    },
    showDeleteModal() {
      this.$refs.deleteComponentModal.show();
    }
  })
});